import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNACard, DNADivider, Iffy, Tabs } from '@alucio/lux-ui';
import { ReportProvider, useReport } from 'src/components/Reports/ReportProvider';
import { ReportSelector } from 'src/components/Reports/ReportSelector';
import { EmbeddedReport } from 'src/components/Reports/EmbeddedReport';
import useFeatureFlags from 'src/hooks/useFeatureFlags/useFeatureFlags';
import { TitleBar } from 'src/components/DNA';

const styles = StyleSheet.create({
  iFrame: {
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: 10,
  },
  tabsContainer: {
    marginHorizontal: 10,
    marginBottom: 16,
  },
  title: {
    marginBottom: 16,
  },
});

const viewerFolder = 'Beacon_Embedded_Viewer'
const FIGMA_ANALYTICS_DEMO_URL = 'https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com' +
  '%2Fproto%2FEuo76my4iCPmlWBh5kpcyp%2FAnalytics?page-id=786%3A15789&node-id=2730-3473&node-type=canvas' +
  '&hide-ui=1&viewport=911%2C2923%2C0.53&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=2730%3A3473';

const ViewerTabs = () => {
  const { onDashboardChange, setIsTeamViewer, isTeamLeader } = useReport();
  const tabs =  isTeamLeader ? [{ title: 'My Reports' }, { title: 'Team Reports' }]
    : [{ title: 'My Reports' }];
  const [selectedTab, setSelectedTab] = useState(tabs[0].title);
  return (
    <DNABox appearance="col" style={styles.tabsContainer}>
      <Iffy is={isTeamLeader}>
        <Tabs
          selectedTab={selectedTab}
          selectedTabVariant="primary"
          tabs={tabs}
          onSelectTab={(tab) => {
            const isTeamViewer = tab === 'Team Reports';
            setSelectedTab(tab);
            setIsTeamViewer(isTeamViewer);
            onDashboardChange(isTeamViewer);
          }}
        />
        <DNADivider />
      </Iffy>
    </DNABox>
  );
};

const ReportsViewer = () => {
  const enableDemoMode = useFeatureFlags('enableDemoMode');

  return (

    <ReportProvider folderName={viewerFolder}>
      <DNABox
        appearance="col"
        fill={!enableDemoMode}
      >
        { /* HEADER */}
        <DNABox style={styles.title} >
          <TitleBar title="Analytics" description="Track performance and uncover actionable insights" />
        </DNABox>
        <Iffy is={!enableDemoMode}>
          <DNACard appearance="outline">
            <DNABox appearance="col" fill>
              <ViewerTabs />
              <ReportSelector />
              <EmbeddedReport />
            </DNABox>
          </DNACard>

        </Iffy>
        <Iffy is={enableDemoMode}>
          <DNABox fill>
            <iframe
              style={styles.iFrame}
              width="1240"
              height="1828"
              src={FIGMA_ANALYTICS_DEMO_URL}
              allowFullScreen
            />
          </DNABox>
        </Iffy>
      </DNABox>
    </ReportProvider >
  )
}

ReportsViewer.displayName = 'ReportsViewer';

export default ReportsViewer
